import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {DateType} from '../enums/date-type.enum';
import {DateTimeUnitTypes} from '../enums/date-time-unit-types.enum';
import {OverTimeGraphType} from '../enums/over-time-graph-type.enum';
import {DateTimeUnitTypeList, StatisticsTypesList} from '../enums/statistics.constants';
import dayjs from 'dayjs';

@Injectable()
export class ReportDataCacheService {
    constructor() {}

    filterCache = {};
    dataCache = {};

    getReportFilters(report): any {
        let filters = this.getReportFiltersByIdentifier(report.reportIdentifier);
        if (!filters) {
            filters = this.getFilterDefaultValues(report);
            this.setReportFiltersByIdentifier(report.reportIdentifier, filters);
        }
        return _.cloneDeep(filters);
    }

    setReportFilters(reportIdentifier, newFilters): void {
        this.setReportFiltersByIdentifier(reportIdentifier, newFilters);
    }

    getLastReportData(reportIdentifier): any {
        const data = this.getReportDataByIdentifier(reportIdentifier);
        return _.cloneDeep(data);
    }

    setLastReportData(reportIdentifier, data): void {
        this.setReportDataByIdentifier(reportIdentifier, data);
    }

    clearCache(): void {
        this.filterCache = {};
        this.dataCache = {};
    }

    getReportDataByIdentifier(reportIdentifier): any {
        return this.dataCache[reportIdentifier];
    }

    setReportDataByIdentifier(reportIdentifier, data): void {
        this.dataCache[reportIdentifier] = _.cloneDeep(data);
    }

    getReportFiltersByIdentifier(reportIdentifier): any {
        return this.filterCache[reportIdentifier];
    }

    setReportFiltersByIdentifier(reportIdentifier, filters): void {
        this.filterCache[reportIdentifier] = _.cloneDeep(filters);
    }

    getFilterDefaultValues(report): any {
        return {
            reportIdentifier: report.reportIdentifier,
            dateType: DateType.RELATIVE,
            date: {
                startDate: dayjs().startOf('day').second(0).millisecond(0),
                endDate: dayjs().endOf('day').second(0).millisecond(0)
            },
            timeUnitOptions: DateTimeUnitTypeList,
            relativeTimeUnit: DateTimeUnitTypes.HOUR,
            relativeTimeUnitValue: 3,
            numberOfElements: 5,
            numberOfStackedElements: 5,
            statisticsOptions: this.getStatisticsOptions(report.statistics.options),
            singleStatistic: report.statistics.defaultStatistic,
            multipleStatistics: [report.statistics.defaultStatistic],
            chartViewOptions: report.graphViews.options,
            chartView: report.graphViews.defaultGraphView,
            elementOptions: [],
            elements: [],
            availableFilters: report.filters,
            lastUpdateTime: dayjs().format('MMMM Do YYYY, HH:mm'),
            overTimeGraphType: this.getOverTimeGraphType(report.reportIdentifier)
        };
    }

    getStatisticsOptions(statistics): any {
        return StatisticsTypesList.filter((statisticType => {
            return statistics.indexOf(statisticType.value) !== -1;
        }));
    }

    getOverTimeGraphType(reportIdentifier): any {
      if (reportIdentifier === 'customerSessionsOverTime' || reportIdentifier === 'voipPeerSessionOverTime'
        || reportIdentifier === 'peerConnectionSessionOverTime') {
        return OverTimeGraphType.MULTIPLE_STATISTICS;
      }
      return OverTimeGraphType.MULTIPLE_ELEMENTS;
    }
}
